var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["data-act", "aria-controls"];
import { computed } from 'vue';
import PaymentItem from "./PaymentItem.vue";
import { PaymentItemProps } from "./utils";
import Price from "../../Price.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BNPLPayment',
    props: /*@__PURE__*/ _mergeModels(__assign(__assign({}, PaymentItemProps), { sum: { type: Number, required: true }, actionName: { type: String, required: true } }), {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup: function (__props) {
        var props = __props;
        var disabled = computed(function () {
            if (props.disabled) {
                return true;
            }
            if (props.sum < props.system.minAmount) {
                return true;
            }
            return props.system.maxAmount && props.sum > props.system.maxAmount;
        });
        var value = _useModel(__props, "modelValue");
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(PaymentItem, {
                system: _ctx.system,
                disabled: disabled.value,
                modelValue: value.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((value).value = $event); })
            }, {
                message: _withCtx(function () { return [
                    (_ctx.system.minAmount && __props.sum < _ctx.system.minAmount)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[1] || (_cache[1] = _createTextVNode("\n        Доступно при заказе от\n        ", -1 /* CACHED */)),
                            _createVNode(Price, {
                                amount: _ctx.system.minAmount
                            }, null, 8 /* PROPS */, ["amount"])
                        ], 64 /* STABLE_FRAGMENT */))
                        : (_ctx.system.maxAmount && __props.sum > _ctx.system.maxAmount)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[2] || (_cache[2] = _createTextVNode("\n        Доступно при заказе до\n        ", -1 /* CACHED */)),
                                _createVNode(Price, {
                                    amount: _ctx.system.maxAmount
                                }, null, 8 /* PROPS */, ["amount"])
                            ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode("\n        Вы исчерпали количество попыток на оплату этим способом. Пожалуйста, попробуйте снова завтра.\n      ")
                            ], 64 /* STABLE_FRAGMENT */))
                ]; }),
                suffix: _withCtx(function () { return [
                    _createElementVNode("button", {
                        "data-act": __props.actionName,
                        class: "circle-btn win",
                        type: "button",
                        "aria-controls": __props.actionName
                    }, __spreadArray([], __read((_cache[3] || (_cache[3] = [
                        _createElementVNode("span", { class: "circle-btn__label" }, "?", -1 /* CACHED */)
                    ]))), false), 8 /* PROPS */, _hoisted_1)
                ]; }),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["system", "disabled", "modelValue"]));
        };
    }
});
